import Vue from 'vue'
import Router from 'vue-router'
import Help from '@/components/Help'
import Activity from '@/components/Activity'
import Passes from '@/components/Passes'
import CreatePass from '@/components/CreatePass';
import EditPass from '@/components/EditPass';
import PassTypes from '@/components/PassTypes'
import PassType from '@/components/PassType'
import Users from '@/components/Users'
import Login from '@/components/Login'
import SetPassword from '@/components/SetPassword'
import SetAppPassword from '@/components/SetAppPassword';
import ResetPassword from '@/components/ResetPassword'
import PrintPass from '@/components/PrintPass'
import Configuration from '@/components/Configuration';
import PassGroupSetup from '@/components/PassGroupSetup';
import api from '../api'


Vue.use(Router)

export default new Router({
  routes: [,
    { path: '/login',
      component: Login,
      beforeEnter(to, from, next){
        if(api.loggedIn()) {
          next('/')
        } else {
          next()
        }
      }
    },
    { path: '/',
      beforeEnter (to, from, next) {
        if(!api.loggedIn()) {
          next('/login')
        } else {
          next('/activity')
        }
      }
    },
    {
      path: '/reset_password',
      name:'reset_password',
      component: ResetPassword,
    },
    {
      path: '/pass-setup/:token',
      name: 'Group Pass Setup',
      component: PassGroupSetup,
    },
    { path: '/set_password/:email_prop/:reset_token_prop',
      name: 'Set Password',
      component: SetPassword,
      props: true
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity,
      beforeEnter: requireAuth
    },
    {
      path: '/passes',
      name: 'Passes',
      component: Passes,
      beforeEnter: requireManageOwnPasses 
    },
    {
      path: "/pass/create",
      name: "Pass",
      component: CreatePass,
      beforeEnter: requireManageOwnPasses 
    },
    {
      path: '/passtypes',
      name: 'PassTypes',
      component: PassTypes,
      beforeEnter: requireManageOwnPasses 
    },
    {
      path: '/passtypes/:id',
      name: 'PassType',
      component: PassType,
      beforeEnter: requireManageOwnPasses 
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      beforeEnter: requireManageOwnPasses 
    },
    {
      path: '/passes/:passId/edit',
      name: 'Edit Passes',
      component: EditPass,
      beforeEnter: requireManageOwnPasses 
    },
    {
      path: '/passes/:passId/print',
      name: 'Print Passes',
      component: PrintPass,
      beforeEnter: requireManageOwnPasses 
    },
    {
      path: '/configuration',
      name: 'Configuration',
      component: Configuration,
      beforeEnter: requireManageOwnPasses 
    },
    {
      path: '/app/setpassword',
      name: "Set Password",
      component: SetAppPassword 
    },
    { path: '/logout',
      beforeEnter (to, from, next) {
        api.logout().then(res => {
          next('/login')
        })
      }
    }
  ]
})

function requireAuth (to, from, next) {
  if (!api.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function requireAdmin (to, from, next) {
  if (!api.loggedIn() || !api.userIsAdmin()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function requireManageOwnPasses (to, from, next) {
  if (!api.loggedIn() || !api.canManageOwnPasses()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}




// WEBPACK FOOTER //
// ./src/router/index.js